// Todo: the below was intended to only import what's needed, however everything still gets imported and bloats the final file
// I think you have to start changing Babel settings and that could have a big knock-on effect
import { CategoryScale, Chart, LinearScale, BarController, BarElement } from "Vendor/chart.js";

export function PollStats(element, data) {
	var self = this;
	this.rootElement = element;
	this.chart = null;
	this.data = data || null;

	this.init = function() {
		this.initChartPlugin();
	};

	this.isMobileViewport = function() {
		if(!window.matchMedia) { // Browser doesn't support this method, we can't determine if it's a mobile device.
			return false;
		}
		return window.matchMedia('(max-width: 767px)').matches
	};

	this.initChartPlugin = function(attempt) {
		console.log("initChartPlugin");
		// Ensure the canvas exists on the page before initialising the chart plugin
		var ctx = $(this.rootElement);
		if (!ctx.length) {
			console.log("Canvas exists");
			return;
		}

		// On page load, Chart may not quite be ready...
		attempt = attempt || 0;
		if(typeof Chart === "undefined" && attempt < 10){
			attempt++;
			setTimeout(function() {
				return self.initChartPlugin(attempt);
			}, attempt * 1000);
			return;
		}

		Chart.register(
			CategoryScale,
			LinearScale,
			BarController,
			BarElement
		);

		this.chart = new Chart(ctx, {
			type: 'bar',
			data: {
				labels: this.getAnswers(),
				datasets: [{
					axis: 'y', // Make it horizontal
					label: '', // No labels for this chart
					data: this.getPercentages(),
					backgroundColor: this.getBackgroundColours(),
					barPercentage: 1
				}]
			},
			options: {
				// Make it horizontal
				indexAxis: 'y',
				// Without this value set, the library doesn't respect the height of the container it lives in, resulting in it breaking out of its containing element.
				maintainAspectRatio: false,
				scales: {
					y: {
						// Disable y-axis grid lines (lines between the bars).
						grid: {
							display: false
						},
						ticks: {
							fontSize: this.isMobileViewport() ? 12 : 16
						}
					},
					x: {
						grid: {
							display: true
						},
						ticks: {
							beginAtZero: true,
							max: 100,
							callback: (value) => value + '%',
						}
					}
				}
			}
		});
	};

	/**
	 * @return The answer the user selected in this poll. It will always have a value, as the results are never shown until a vote has been made.
	 */
	this.getSelectedAnswer = function() {
		if(this.data) {
			return this.data.selectedAnswer;
		}
		return this.rootElement.attr('data-selected-answer');
	};

	/**
	 * @return An array of background colours for the chart. The selected option will be highlighted in a different colour.
	 */
	this.getBackgroundColours = function() {
		var colours = [];
		var answers = this.getAnswers();
		answers.forEach(function(a) {
			if (a === self.getSelectedAnswer()) {
				colours.push('#44b4e4');
			} else {
				colours.push('#DDD');
			}
		});
		return colours;
	};

	/**
	 * @return An array of answers to use on the Y-axis of the chart.
	 */
	this.getAnswers = function() {
		if(this.data) {
			return this.data.answers.split(',');
		}
		return this.rootElement.attr('data-answers').split(',');
	};

	/**
	 * @return The data for the chart.
	 */
	this.getPercentages = function() {
		if(this.data) {
			return this.data.percentages.split(',');
		}
		return this.rootElement.attr('data-percentages').split(',');
	};

	this.init();
}